import {
  extractData,
  getSeoKey,
  getServicePlans,
  ServicePlansResponse,
} from "api"
import SeoMetaData, { SeoMetadataWithImage } from "common/SeoMetaData"
import ServicePlansPage from "components/pages/ServicePlans/ServicePlansPage"
import { GetStaticProps } from "next"

type ServicePlansProps = {
  pageData: ServicePlansResponse
  seo: SeoMetadataWithImage
}

export const getStaticProps: GetStaticProps<ServicePlansProps> = async () => {
  const dataServicePlans = await getServicePlans().then(extractData)
  const { data } = await getSeoKey("servicePlans")
  const seo = {
    title: data?.body?.title || "",
    description: data?.body?.description || "",
    keywords: data?.body?.keywords || "",
  }
  return {
    props: {
      pageData: dataServicePlans?.body,
      seo: seo,
    },
    revalidate: 60,
  }
}

const ServicePlans = ({ pageData, seo }: ServicePlansProps) => {
  return (
    <>
      <SeoMetaData data={seo} />
      <ServicePlansPage data={pageData} />
    </>
  )
}

export default ServicePlans
